import { useDeviceType } from '@cian/ui-kit';
import { DiscountConditions } from 'shared/components/DiscountConditions';
import { DiscountConditionItemContainer } from '../DiscountConditionItemContainer';
import { ButtonLinkContainer } from '../ButtonLinkContainer';
import { caMortgageDiscountSellActivate } from 'shared/components/tracking';
import { IConditions } from 'shared/types/utp';
import { DISCOUNT_CONDITIONS } from 'shared/constants/discountConditions';
import { useSelector } from 'react-redux';
import { selectMortrageInfo } from 'shared/selectors/selectMortrageInfo';

export const DiscountConditionsContainer: React.FC = () => {
  const device = useDeviceType();

  const mortrageInfo = useSelector(selectMortrageInfo);

  const prepareConditions = (conditions: IConditions[]): IConditions[] => {
    conditions[0].basePercent = String(mortrageInfo.baseRate) + '%';
    conditions[0].percent = String(mortrageInfo.subsidizedRate) + '%';
    conditions[0].notice = 'ПСК: ' + mortrageInfo.psk;

    conditions[1].percent = String(mortrageInfo.downPaymentRate) + '%';

    conditions[2].percent = String(mortrageInfo.objectPriceRateDiscount) + '%';

    return conditions;
  };

  return (
    <DiscountConditions
      Item={DiscountConditionItemContainer}
      device={device}
      discountConditions={prepareConditions(DISCOUNT_CONDITIONS)}
      buttonLink={
        <ButtonLinkContainer onSendCa={() => caMortgageDiscountSellActivate('conditions', device)}>
          Подключить скидку на ипотеку
        </ButtonLinkContainer>
      }
    />
  );
};
